import { useCallback } from 'react';
import { formatGraphqlErrors } from 'utils/helpers';
import { useMutation } from '@apollo/client/react';
import { ResetPasswordDocument } from 'graphql/generated/graphql';

const useResetPassword = () => {
  const [resetPasswordMutation] = useMutation(ResetPasswordDocument);

  const resetPassword = useCallback(
    async ({ password, token }: { password: string; token: string }) => {
      try {
        await resetPasswordMutation({ variables: { token, newPasswordPlain: password } });
      } catch (error) {
        const e = formatGraphqlErrors(error);
        throw e;
      }
    },
    [resetPasswordMutation],
  );

  return resetPassword;
};

export default useResetPassword;
